import VerticalPopularRequest from './VerticalPopularRequest';

export default VerticalPopularRequest;
